import React, { useEffect, useState } from 'react';

import { useSnackbar } from '../../../context/SnackBarContext';

import {
	TextField,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Grid,
} from '@mui/material';

import { actualizar, cambiarUnEstado } from '../../../services/otg.service';

export default function ModalFacturado(props) {
	const { open, close, otgSeleccionada = {}, id_colaborador, updateComponent } =
		props;

	const { showSnackbar } = useSnackbar();

	const handleClickSnackbar = (message, severity) => {
		showSnackbar({
			message,
			severity,
		});
	};

	const handleClose = () => {
		if (typeof close === 'function') close(!open);
	};

	const [datos, setDatos] = useState({
		id_otg: otgSeleccionada?.id_otg ?? null,
		precio: '',
		nro_factura: '',
	});

	useEffect(() => {
		setDatos((prev) => ({
			...prev,
			id_otg: otgSeleccionada?.id_otg ?? null,
		}));

		console.log('OTG seleccionada actualizada:', otgSeleccionada);
	}, [otgSeleccionada]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setDatos((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const guardarDatos = async () => {
		try {
			console.log('Datos a guardar:', datos);
			console.log('Valor original de envio_calidad:', otgSeleccionada?.envio_calidad);

			// Guardar datos ingresados en backend
			await actualizar({
				...datos,
				id_otg: datos.id_otg,
			});

			// Convertir envio_calidad a booleano
			const envioCalidadBoolean =
				otgSeleccionada?.envio_calidad === true ||
				otgSeleccionada?.envio_calidad === 'true' ||
				otgSeleccionada?.envio_calidad === 1;

			console.log('envioCalidadBoolean evaluado:', envioCalidadBoolean);

			// Determinar nuevo estado
			const nuevoEstado = envioCalidadBoolean ? 8 : 5;
			console.log('Nuevo estado asignado:', nuevoEstado);

			await cambiarUnEstado({
				id_otg: datos.id_otg,
				id_estado: nuevoEstado,
				id_colaborador: id_colaborador,
			});

			const mensaje =
				nuevoEstado === 8
					? 'OTG enviada a calidad satisfactoriamente'
					: 'Precio registrado satisfactoriamente';

			handleClickSnackbar(mensaje, 'success');

			if (typeof updateComponent === 'function') updateComponent(true);
			handleClose();
		} catch (err) {
			console.error(err);
			handleClickSnackbar('Error al cambiar estado', 'error');
		}
	};

	return (
		<>
			<Dialog open={!!open} onClose={handleClose} fullWidth maxWidth="sm">
				<DialogTitle>Ingrese los siguientes datos:</DialogTitle>

				<DialogContent>
					<Grid container justifyContent="center" direction="column" spacing={2} sx={{ mt: 1 }}>
						<Grid item>
							<TextField
								fullWidth
								margin="dense"
								onChange={handleChange}
								name="precio"
								label="Precio a pagar por el cliente"
								value={datos.precio}
							/>
						</Grid>
						<Grid item>
							<TextField
								fullWidth
								margin="dense"
								onChange={handleChange}
								name="nro_factura"
								label="Nro de factura"
								value={datos.nro_factura}
							/>
						</Grid>
					</Grid>
				</DialogContent>

				<DialogActions>
					<Button
						variant="outlined"
						sx={{ backgroundColor: 'red', color: 'white' }}
						onClick={handleClose}
					>
						Cancelar
					</Button>
					<Button
						variant="contained"
						onClick={guardarDatos}
					>
						Aceptar
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
